import { SxProps } from '@mui/material'

import theme from '../../../../../../../../../../shared/styles/themes/default.theme'

const styles = {
  container: {
    marginBottom: 2
  },

  title: {
    marginBottom: 1,
    textAlign: 'left',
    fontWeight: theme.typography.fontWeightMedium
  } as SxProps,

  accordion: {
    marginBottom: 2,
    '&:last-child': { marginBottom: 0 }
  },

  accordionHeaderContent: {
    width: '100%'
  },

  offerRequestFirstRow: {
    display: 'flex',
    alignItems: 'flex-start'
  },

  offerRequestFirstRowChipsContainer: {
    display: 'flex',
    gap: 1
  },

  offerRequestTitle: {
    marginBottom: 1
  },

  shopperInfo: {
    color: 'text.secondary'
  },

  itemsContainer: {
    paddingTop: 2
  },

  itemCard: {
    marginBottom: 2,
    '&:last-child': { marginBottom: 0 }
  },

  skeletonContainer: {
    // marginBottom: 2
  },

  skeletonItem: {
    marginBottom: 2,
    borderRadius: 2
  },

  fulfillmentHeader: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 0.75,
    textAlign: 'left'
  } as SxProps,

  fulfillmentHeaderTitleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1.5,
    flexWrap: 'wrap'
  },

  fulfillmentHeaderTitle: {
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: '0.01em',
    overflowWrap: 'anywhere'
  } as SxProps,

  fulfillmentHeaderChips: {
    display: 'flex',
    gap: 0.75,
    flexShrink: 0,
    flexWrap: 'wrap'
  },

  fulfillmentHeaderMeta: {
    color: 'text.secondary',
    textAlign: 'left'
  } as SxProps,

  fulfillmentBody: {
    paddingTop: 2,
    paddingBottom: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 2.5,
    textAlign: 'left'
  } as SxProps,

  fulfillmentSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    textAlign: 'left'
  } as SxProps,

  fulfillmentSectionLabel: {
    fontSize: '0.6875rem',
    fontWeight: theme.typography.fontWeightBold,
    color: 'text.secondary',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    textAlign: 'left'
  } as SxProps,

  fulfillmentItemRow: {
    display: 'flex',
    gap: 1.75,
    padding: 1.5,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 1.5,
    alignItems: 'flex-start',
    textAlign: 'left'
  } as SxProps,

  fulfillmentItemImage: {
    width: 56,
    height: 56,
    objectFit: 'cover',
    borderRadius: 1,
    flexShrink: 0,
    border: `1px solid ${theme.palette.divider}`
  },

  fulfillmentItemImagePlaceholder: {
    width: 56,
    height: 56,
    borderRadius: 1,
    backgroundColor: theme.palette.action.hover,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    border: `1px solid ${theme.palette.divider}`
  },

  fulfillmentItemContent: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
    alignItems: 'flex-start',
    textAlign: 'left'
  } as SxProps,

  fulfillmentItemTitle: {
    fontWeight: theme.typography.fontWeightMedium,
    lineHeight: 1.3,
    textAlign: 'left'
  } as SxProps,

  fulfillmentItemMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    flexWrap: 'wrap',
    color: 'text.secondary',
    fontSize: '0.8125rem',
    textAlign: 'left'
  } as SxProps,

  fulfillmentItemMetaText: {
    color: 'text.secondary'
  } as SxProps,

  fulfillmentItemMetaDivider: {
    width: '3px',
    height: '3px',
    borderRadius: '50%',
    backgroundColor: theme.palette.text.disabled,
    flexShrink: 0
  },

  fulfillmentItemMetaChips: {
    display: 'flex',
    gap: 0.5,
    flexWrap: 'wrap'
  },

  fulfillmentRecipientContact: {
    color: 'text.primary',
    textAlign: 'left'
  } as SxProps,

  fulfillmentRecipientAddress: {
    padding: 1.5,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 1.5,
    color: 'text.secondary',
    whiteSpace: 'pre-line',
    textAlign: 'left',
    lineHeight: 1.6,
    fontFamily: theme.typography.body2.fontFamily,
    fontSize: theme.typography.body2.fontSize
  } as SxProps
}

export default styles
